import i18next from 'i18next';

import { DeviceOS } from 'enums';

const isMobile = () =>
  window.matchMedia('(pointer: coarse)').matches &&
  window.matchMedia('(hover: none)').matches;

const getDeviceOsLabel = (deviceOs: DeviceOS) => {
  const { t } = i18next;
  const key = `device_os.${deviceOs}`;
  return t(key as any, key);
};

export const deviceUtils = {
  isMobile,
  getDeviceOsLabel,
};
